import { useCallback, useLayoutEffect } from 'react';

export const useOutSideClick = (
  protectedClassName: string,
  closeAction: () => void,
  additionalCondition: boolean,
) => {
  const clickHandler = useCallback(
    (e: MouseEvent) => {
      const { target } = e;

      const htmlTarget = target as HTMLElement;

      !(
        htmlTarget.classList.contains(protectedClassName) ||
        htmlTarget.parentElement?.classList.contains(protectedClassName) ||
        htmlTarget.closest(`.${protectedClassName}`)
      ) &&
        additionalCondition &&
        closeAction();
    },
    [closeAction, additionalCondition],
  );

  useLayoutEffect(() => {
    document.addEventListener('click', clickHandler);

    return () => {
      document.removeEventListener('click', clickHandler);
    };
  }, [additionalCondition]);
};
